module.exports = __webpack_public_path__ + "media/chrom.73e09d46.wav";